function scrollInEvent(
  elementId,
  pageId,
  eventId,
  autoStopEventId,
  mediaQueries,
  actionListId
) {
  return {
    id: eventId,
    name: "",
    animationType: "custom",
    eventTypeId: "SCROLL_INTO_VIEW",
    action: {
      id: "",
      actionTypeId: "GENERAL_START_ACTION",
      config: {
        delay: 0,
        easing: "",
        duration: 0,
        actionListId,
        affectedElements: {},
        playInReverse: false,
        autoStopEventId,
      },
    },
    mediaQueries,
    target: {
      id: `${pageId}|${elementId}`,
      appliesTo: "ELEMENT",
      styleBlockIds: [],
    },
    targets: [
      {
        id: `${pageId}|${elementId}`,
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
    ],
    config: {
      loop: false,
      playInReverse: false,
      scrollOffsetValue: 50,
      scrollOffsetUnit: "%",
      delay: null,
      direction: null,
      effectIn: null,
    },
    createdOn: Date.now(),
  };
}

function scrollOutEvent(
  elementId,
  pageId,
  eventId,
  autoStopEventId,
  mediaQueries,
  actionListId
) {
  return {
    id: eventId,
    name: "",
    animationType: "custom",
    eventTypeId: "SCROLL_OUT_OF_VIEW",
    action: {
      id: "",
      actionTypeId: "GENERAL_START_ACTION",
      config: {
        delay: 0,
        easing: "",
        duration: 0,
        actionListId,
        affectedElements: {},
        playInReverse: false,
        autoStopEventId,
      },
    },
    mediaQueries,
    target: {
      id: `${pageId}|${elementId}`,
      appliesTo: "ELEMENT",
      styleBlockIds: [],
    },
    targets: [
      {
        id: `${pageId}|${elementId}`,
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
    ],
    config: {
      loop: false,
      playInReverse: false,
      scrollOffsetValue: 0,
      scrollOffsetUnit: "%",
      delay: null,
      direction: null,
      effectIn: null,
    },
    createdOn: Date.now(),
  };
}

function fadeInImageAction(actionId, elementId) {
  return {
    id: actionId,
    title: `Layout 350 image ${elementId} [Fade In]`,
    actionItemGroups: [
      {
        actionItems: [
          {
            id: `${actionId}-n`,
            actionTypeId: "STYLE_OPACITY",
            config: {
              delay: 0,
              easing: "ease",
              duration: 200,
              target: {
                selector: `.layout350_image.is-image${elementId}`,
                selectorGuids: [
                  "45c4104d-27a9-1af3-10f3-f13498050f02",
                  "45c4104d-27a9-1af3-10f3-f13498050f0a",
                ],
              },
              value: 0,
              unit: "",
            },
          },
        ],
      },
      {
        actionItems: [
          {
            id: `${actionId}-n-2`,
            actionTypeId: "STYLE_OPACITY",
            config: {
              delay: 0,
              easing: "ease",
              duration: 500,
              target: {
                selector: `.layout350_image.is-image${elementId}`,
                selectorGuids: [
                  "45c4104d-27a9-1af3-10f3-f13498050f02",
                  "45c4104d-27a9-1af3-10f3-f13498050f0a",
                ],
              },
              value: 1,
              unit: "",
            },
          },
        ],
      },
    ],
    useFirstGroupAsInitialState: true,
    createdOn: Date.now(),
  };
}

function fadeOutImageAction(actionId, elementId) {
  return {
    id: actionId,
    title: `Layout 350 image ${elementId} [Fade Out]`,
    actionItemGroups: [
      {
        actionItems: [
          {
            id: `${actionId}-n`,
            actionTypeId: "STYLE_OPACITY",
            config: {
              delay: 0,
              easing: "ease",
              duration: 500,
              target: {
                selector: `.layout350_image.is-image${elementId}`,
                selectorGuids: [
                  "45c4104d-27a9-1af3-10f3-f13498050f02",
                  "45c4104d-27a9-1af3-10f3-f13498050f0a",
                ],
              },
              value: 0,
              unit: "",
            },
          },
        ],
      },
    ],
    useFirstGroupAsInitialState: false,
    createdOn: Date.now(),
  };
}

function generateEvents(pageId, tabIds) {
  const events = {};
  let i;

  tabIds.forEach((id, index) => {
    const openEventMainId = index === 0 ? "e" : `e-${index * 2 + 1}`; // fade in event
    const closeEventMainId = index === 0 ? "e-2" : `e-${index * 2 + 2}`; // fade out event

    const openActionMainId = index === 0 ? "a" : `a-${index * 2 + 1}`; // fade in action id
    const openActionSmallId = index === 0 ? "a-2" : `a-${index * 2 + 2}`; // fade out action id

    events[openEventMainId] = scrollInEvent(
      id.tabId,
      pageId,
      openEventMainId,
      closeEventMainId,
      ["main", "medium"],
      openActionMainId
    );
    events[closeEventMainId] = scrollOutEvent(
      id.tabId,
      pageId,
      closeEventMainId,
      openEventMainId,
      ["main", "medium"],
      openActionSmallId
    );
    i = index;
  });

  // all events with the background fades id
  tabIds.forEach((id) => {
    i += 1;
    const openEventMainId = `e-${i * 2 + 1}`; // fade in event
    const closeEventMainId = `e-${i * 2 + 2}`; // fade out event

    events[openEventMainId] = scrollInEvent(
      id.tabId,
      pageId,
      openEventMainId,
      closeEventMainId,
      ["main", "medium", "small", "tiny"],
      "a-23"
    );
    events[closeEventMainId] = scrollOutEvent(
      id.tabId,
      pageId,
      closeEventMainId,
      openEventMainId,
      ["main", "medium", "small", "tiny"],
      "a-22"
    );
  });

  return events;
}

function generateActions(imageIds) {
  const actions = {};

  imageIds.forEach((id, index) => {
    const openActionMainId = index === 0 ? "a" : `a-${index * 2 + 1}`; // fade in image
    const openActionSmallId = index === 0 ? "a-2" : `a-${index * 2 + 2}`; // fade out image

    actions[openActionMainId] = fadeInImageAction(openActionMainId, id.imageId);
    actions[openActionSmallId] = fadeOutImageAction(
      openActionSmallId,
      id.imageId
    );
  });

  return actions;
}

function getEvents(pageId, tabIds, imageIds) {
  const events = generateEvents(pageId, tabIds);
  const actions = generateActions(imageIds);

  return {
    events: {
      ...events,
    },
    actionLists: {
      ...actions,
      "a-23": {
        id: "a-23",
        title: "Background [Fade In]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-23-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: [0.25, 0.25, 0.75, 0.75],
                  duration: 400,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".background-holder",
                    selectorGuids: ["46dbbb55-50b6-8c40-b791-6d2b74373a7a"],
                  },
                  value: 0,
                  unit: "",
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-23-n-2",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".background-holder",
                    selectorGuids: ["46dbbb55-50b6-8c40-b791-6d2b74373a7a"],
                  },
                  value: 1,
                  unit: "",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1648713066350,
      },
      "a-22": {
        id: "a-22",
        title: "Background [Fade Out]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-22-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".background-holder",
                    selectorGuids: ["46dbbb55-50b6-8c40-b791-6d2b74373a7a"],
                  },
                  value: 0,
                  unit: "",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1648713066350,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
